import { render } from "./OTTPlatformPage.vue?vue&type=template&id=7ececaf4&ts=true"
import script from "./OTTPlatformPage.vue?vue&type=script&lang=ts"
export * from "./OTTPlatformPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__